import { useState } from "react";
import { ChevronRight, ShieldX } from "lucide-react";
import { api } from "../../lib/api";
import { stages } from "../../lib/format";
import PasswordInput from "../ui/PasswordInput";

export default function Login({ onLogin, deactivationMsg = "" }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await api("post", "/auth/login", { email, password });
      onLogin(r.data);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Could not sign in");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-art">
        <div className="login-logo-wrap">
          <img src="/pinaki_logo.png" alt="Pinaki Solutions" className="login-logo-img" />
        </div>
        {/* <p className="eyebrow">PINAKI SOLUTIONS</p> */}
        <h1>One order.<br /><em>Every team aligned.</em></h1>
        <p className="login-copy">A single source of truth for every client order — from first brief to payment received.</p>
        <div className="lifecycle-strip">
          {stages.slice(0, 8).map((s, i) => (
            <span key={s} className={i < 4 ? "active" : ""}>{i + 1}</span>
          ))}
        </div>
        <div className="login-credit">
          Designed &amp; Developed by Ashoka Technovations
        </div>
      </div>
      <section className="login-panel">
        <div>
          <div className="small-label">WELCOME BACK</div>
          <h2>Sign in to your workspace</h2>
          <p className="muted">Manage the Pinaki order lifecycle with clarity.</p>
        </div>
        <form onSubmit={submit} data-testid="login-form">
          <label>Email address
            <input data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="name@pinakisolutions.com" required />
          </label>
          <label>Password
            <PasswordInput
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </label>
          {deactivationMsg && (
            <div
              style={{
                background: "#fef2f2",
                border: "1.5px solid #fca5a5",
                borderRadius: 8,
                padding: "12px 14px",
                marginBottom: 4,
                display: "flex",
                alignItems: "flex-start",
                gap: 10,
                fontSize: 13,
                color: "#991b1b",
              }}
            >
              <ShieldX size={16} style={{ flexShrink: 0, marginTop: 1, color: "#dc2626" }} />
              <span>{deactivationMsg}</span>
            </div>
          )}
          {error && <div className="error" data-testid="login-error">{error}</div>}
          <button data-testid="login-submit-button" className="primary-btn" disabled={busy}>
            {busy ? "Signing in…" : "Sign in to CRM"}<ChevronRight size={17} />
          </button>
        </form>
      </section>
    </main>
  );
}
